'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _FormField = require('./FormField');

var _FormField2 = _interopRequireDefault(_FormField);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectField = function (_Component) {
  _inherits(SelectField, _Component);

  function SelectField() {
    _classCallCheck(this, SelectField);

    var _this = _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(SelectField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          autofocus = _props.autofocus,
          disabled = _props.disabled,
          name = _props.name,
          options = _props.options,
          placeholder = _props.placeholder,
          size = _props.size,
          defaultValue = _props.defaultValue,
          value = _props.value,
          labelClass = _props.labelClass,
          descriptionClass = _props.descriptionClass,
          controlClass = _props.controlClass,
          errorClass = _props.errorClass,
          hintClass = _props.hintClass,
          hint = _props.hint,
          label = _props.label,
          description = _props.description,
          required = _props.required,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onFocus = _props.onFocus;

      var error = this.props.error || this.state.error;
      var id = this.props.id || _uuid2.default.v1();

      var fieldAttrs = {
        error: error,
        hint: hint,
        id: id,
        label: label,
        description: description,
        labelClass: labelClass,
        descriptionClass: descriptionClass,
        errorClass: errorClass,
        hintClass: hintClass
      };

      var selectAttrs = {
        autoFocus: autofocus,
        disabled: disabled,
        id: id,
        name: name,
        options: options,
        placeholder: placeholder,
        required: required,
        size: size,
        defaultValue: defaultValue,
        value: value,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: onChange,
        className: controlClass
      };

      var className = (0, _classnames3.default)(_defineProperty({
        SelectField: true
      }, this.props.className, !!this.props.className));

      return _react2.default.createElement(
        _FormField2.default,
        _extends({ className: className }, fieldAttrs),
        _react2.default.createElement(_Select2.default, selectAttrs)
      );
    }
  }]);

  return SelectField;
}(_react.Component);

SelectField.defaultProps = {
  validationMessage: function validationMessage(validity, el) {
    return el.validationMessage;
  }
};
exports.default = SelectField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9TZWxlY3RGaWVsZC5qcyJdLCJuYW1lcyI6WyJTZWxlY3RGaWVsZCIsInN0YXRlIiwicHJvcHMiLCJhdXRvZm9jdXMiLCJkaXNhYmxlZCIsIm5hbWUiLCJvcHRpb25zIiwicGxhY2Vob2xkZXIiLCJzaXplIiwiZGVmYXVsdFZhbHVlIiwidmFsdWUiLCJsYWJlbENsYXNzIiwiZGVzY3JpcHRpb25DbGFzcyIsImNvbnRyb2xDbGFzcyIsImVycm9yQ2xhc3MiLCJoaW50Q2xhc3MiLCJoaW50IiwibGFiZWwiLCJkZXNjcmlwdGlvbiIsInJlcXVpcmVkIiwib25CbHVyIiwib25DaGFuZ2UiLCJvbkZvY3VzIiwiZXJyb3IiLCJpZCIsInYxIiwiZmllbGRBdHRycyIsInNlbGVjdEF0dHJzIiwiYXV0b0ZvY3VzIiwiY2xhc3NOYW1lIiwiZGVmYXVsdFByb3BzIiwidmFsaWRhdGlvbk1lc3NhZ2UiLCJ2YWxpZGl0eSIsImVsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7SUFFTUEsVzs7O0FBT0oseUJBQWU7QUFBQTs7QUFBQTs7QUFFYixVQUFLQyxLQUFMLEdBQWEsRUFBYjtBQUZhO0FBR2Q7Ozs7NkJBRVM7QUFBQSxtQkFzQkosS0FBS0MsS0F0QkQ7QUFBQSxVQUVOQyxTQUZNLFVBRU5BLFNBRk07QUFBQSxVQUdOQyxRQUhNLFVBR05BLFFBSE07QUFBQSxVQUlOQyxJQUpNLFVBSU5BLElBSk07QUFBQSxVQUtOQyxPQUxNLFVBS05BLE9BTE07QUFBQSxVQU1OQyxXQU5NLFVBTU5BLFdBTk07QUFBQSxVQU9OQyxJQVBNLFVBT05BLElBUE07QUFBQSxVQVFOQyxZQVJNLFVBUU5BLFlBUk07QUFBQSxVQVNOQyxLQVRNLFVBU05BLEtBVE07QUFBQSxVQVVOQyxVQVZNLFVBVU5BLFVBVk07QUFBQSxVQVdOQyxnQkFYTSxVQVdOQSxnQkFYTTtBQUFBLFVBWU5DLFlBWk0sVUFZTkEsWUFaTTtBQUFBLFVBYU5DLFVBYk0sVUFhTkEsVUFiTTtBQUFBLFVBY05DLFNBZE0sVUFjTkEsU0FkTTtBQUFBLFVBZU5DLElBZk0sVUFlTkEsSUFmTTtBQUFBLFVBZ0JOQyxLQWhCTSxVQWdCTkEsS0FoQk07QUFBQSxVQWlCTkMsV0FqQk0sVUFpQk5BLFdBakJNO0FBQUEsVUFrQk5DLFFBbEJNLFVBa0JOQSxRQWxCTTtBQUFBLFVBbUJOQyxNQW5CTSxVQW1CTkEsTUFuQk07QUFBQSxVQW9CTkMsUUFwQk0sVUFvQk5BLFFBcEJNO0FBQUEsVUFxQk5DLE9BckJNLFVBcUJOQSxPQXJCTTs7QUF1QlIsVUFBTUMsUUFBUSxLQUFLckIsS0FBTCxDQUFXcUIsS0FBWCxJQUFvQixLQUFLdEIsS0FBTCxDQUFXc0IsS0FBN0M7QUFDQSxVQUFNQyxLQUFLLEtBQUt0QixLQUFMLENBQVdzQixFQUFYLElBQWlCLGVBQUtDLEVBQUwsRUFBNUI7O0FBRUEsVUFBTUMsYUFBYTtBQUNqQkgsb0JBRGlCO0FBRWpCUCxrQkFGaUI7QUFHakJRLGNBSGlCO0FBSWpCUCxvQkFKaUI7QUFLakJDLGdDQUxpQjtBQU1qQlAsOEJBTmlCO0FBT2pCQywwQ0FQaUI7QUFRakJFLDhCQVJpQjtBQVNqQkM7QUFUaUIsT0FBbkI7O0FBWUEsVUFBTVksY0FBYztBQUNsQkMsbUJBQVd6QixTQURPO0FBRWxCQywwQkFGa0I7QUFHbEJvQixjQUhrQjtBQUlsQm5CLGtCQUprQjtBQUtsQkMsd0JBTGtCO0FBTWxCQyxnQ0FOa0I7QUFPbEJZLDBCQVBrQjtBQVFsQlgsa0JBUmtCO0FBU2xCQyxrQ0FUa0I7QUFVbEJDLG9CQVZrQjtBQVdsQlUsc0JBWGtCO0FBWWxCRSx3QkFaa0I7QUFhbEJELDBCQWJrQjtBQWNsQlEsbUJBQVdoQjtBQWRPLE9BQXBCOztBQWlCQSxVQUFNZ0IsWUFBWTtBQUNoQjdCLHFCQUFhO0FBREcsU0FFZixLQUFLRSxLQUFMLENBQVcyQixTQUZJLEVBRVEsQ0FBQyxDQUFDLEtBQUszQixLQUFMLENBQVcyQixTQUZyQixFQUFsQjs7QUFLQSxhQUNFO0FBQUE7QUFBQSxtQkFBVyxXQUFXQSxTQUF0QixJQUFxQ0gsVUFBckM7QUFDRSx3REFBWUMsV0FBWjtBQURGLE9BREY7QUFLRDs7Ozs7O0FBN0VHM0IsVyxDQUNHOEIsWSxHQUFlO0FBQ3BCQyxtQkFEb0IsNkJBQ0RDLFFBREMsRUFDU0MsRUFEVCxFQUNhO0FBQy9CLFdBQU9BLEdBQUdGLGlCQUFWO0FBQ0Q7QUFIbUIsQztrQkErRVQvQixXIiwiZmlsZSI6IlNlbGVjdEZpZWxkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHV1aWQgZnJvbSAndXVpZCdcbmltcG9ydCBjbGFzc25hbWVzIGZyb20gJ2NsYXNzbmFtZXMnXG5pbXBvcnQgRm9ybUZpZWxkIGZyb20gJy4vRm9ybUZpZWxkJ1xuaW1wb3J0IFNlbGVjdCBmcm9tICcuL1NlbGVjdCdcblxuY2xhc3MgU2VsZWN0RmllbGQgZXh0ZW5kcyBDb21wb25lbnQge1xuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIHZhbGlkYXRpb25NZXNzYWdlICh2YWxpZGl0eSwgZWwpIHtcbiAgICAgIHJldHVybiBlbC52YWxpZGF0aW9uTWVzc2FnZVxuICAgIH1cbiAgfVxuXG4gIGNvbnN0cnVjdG9yICgpIHtcbiAgICBzdXBlcigpXG4gICAgdGhpcy5zdGF0ZSA9IHt9XG4gIH1cblxuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHtcbiAgICAgIGF1dG9mb2N1cyxcbiAgICAgIGRpc2FibGVkLFxuICAgICAgbmFtZSxcbiAgICAgIG9wdGlvbnMsXG4gICAgICBwbGFjZWhvbGRlcixcbiAgICAgIHNpemUsXG4gICAgICBkZWZhdWx0VmFsdWUsXG4gICAgICB2YWx1ZSxcbiAgICAgIGxhYmVsQ2xhc3MsXG4gICAgICBkZXNjcmlwdGlvbkNsYXNzLFxuICAgICAgY29udHJvbENsYXNzLFxuICAgICAgZXJyb3JDbGFzcyxcbiAgICAgIGhpbnRDbGFzcyxcbiAgICAgIGhpbnQsXG4gICAgICBsYWJlbCxcbiAgICAgIGRlc2NyaXB0aW9uLFxuICAgICAgcmVxdWlyZWQsXG4gICAgICBvbkJsdXIsXG4gICAgICBvbkNoYW5nZSxcbiAgICAgIG9uRm9jdXNcbiAgICB9ID0gdGhpcy5wcm9wc1xuICAgIGNvbnN0IGVycm9yID0gdGhpcy5wcm9wcy5lcnJvciB8fCB0aGlzLnN0YXRlLmVycm9yXG4gICAgY29uc3QgaWQgPSB0aGlzLnByb3BzLmlkIHx8IHV1aWQudjEoKVxuXG4gICAgY29uc3QgZmllbGRBdHRycyA9IHtcbiAgICAgIGVycm9yLFxuICAgICAgaGludCxcbiAgICAgIGlkLFxuICAgICAgbGFiZWwsXG4gICAgICBkZXNjcmlwdGlvbixcbiAgICAgIGxhYmVsQ2xhc3MsXG4gICAgICBkZXNjcmlwdGlvbkNsYXNzLFxuICAgICAgZXJyb3JDbGFzcyxcbiAgICAgIGhpbnRDbGFzc1xuICAgIH1cblxuICAgIGNvbnN0IHNlbGVjdEF0dHJzID0ge1xuICAgICAgYXV0b0ZvY3VzOiBhdXRvZm9jdXMsXG4gICAgICBkaXNhYmxlZCxcbiAgICAgIGlkLFxuICAgICAgbmFtZSxcbiAgICAgIG9wdGlvbnMsXG4gICAgICBwbGFjZWhvbGRlcixcbiAgICAgIHJlcXVpcmVkLFxuICAgICAgc2l6ZSxcbiAgICAgIGRlZmF1bHRWYWx1ZSxcbiAgICAgIHZhbHVlLFxuICAgICAgb25CbHVyLFxuICAgICAgb25Gb2N1cyxcbiAgICAgIG9uQ2hhbmdlLFxuICAgICAgY2xhc3NOYW1lOiBjb250cm9sQ2xhc3NcbiAgICB9XG5cbiAgICBjb25zdCBjbGFzc05hbWUgPSBjbGFzc25hbWVzKHtcbiAgICAgIFNlbGVjdEZpZWxkOiB0cnVlLFxuICAgICAgW3RoaXMucHJvcHMuY2xhc3NOYW1lXTogISF0aGlzLnByb3BzLmNsYXNzTmFtZVxuICAgIH0pXG5cbiAgICByZXR1cm4gKFxuICAgICAgPEZvcm1GaWVsZCBjbGFzc05hbWU9e2NsYXNzTmFtZX0gey4uLmZpZWxkQXR0cnN9PlxuICAgICAgICA8U2VsZWN0IHsuLi5zZWxlY3RBdHRyc30gLz5cbiAgICAgIDwvRm9ybUZpZWxkPlxuICAgIClcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBTZWxlY3RGaWVsZFxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-forms/lib/SelectField.js
// module id = 1109
// module chunks = 0